import DayDietary from './DayDietary';
import type { SimplePanelProps } from './adapt';

export default function DuringDietary({ eventId, canEdit, day }: SimplePanelProps) {
  return <DayDietary eventId={eventId} canEdit={canEdit} days={day ? [day] : []} date={day} />;
}
